import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fireSmsCreation, isLoggedIn, isSmsCreated, didSmsCreationFailed, isSmsPending, logout } from '../../../../reducers/auth'
import { geti18n } from '../../../../reducers/i18n'
import { trackEvent, EVENTS } from '../../../../tracking/tracking';
import Button from '../../../Button';
import Title from '../../../Title';
import Spinner from '../../../Spinner';
import { Map } from 'immutable';
import P from 'prop-types';
import { RegularError, SmallError } from '../../../InputError';

class PhoneStep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneNumber: this.props.summary.get('phoneNumber', ''),
      validPhone: false
    };
    // this.props.clearUserDetails();
    this.props.logout();
    this.continue = this.continue.bind(this);
    this.setPhone = this.setPhone.bind(this);

  }

  componentDidUpdate() {
    if (this.props.isLoggedIn || this.props.isSmsCreated) {
      this.props.next();
    }
  }

  continue(event) {
    trackEvent(EVENTS.ENTER_PHONE_CLICKED, { phoneNumber: this.state.phoneNumber });
    event.preventDefault();
    const phone = this.state.phoneNumber;
    const phoneValidation = /^[+|0][0-9]{1,15}$/;

    if (phoneValidation.test(phone)) {
      this.props.fireSmsCreation(phone);
      let userData = Map();
      this.props.updateSummary(userData.set('phoneNumber', this.state.phoneNumber));
    } else {
      this.setState({validPhone: true})
    }
  }

  setPhone(event) {
    const phoneNumber = event.target.value;
    this.setState({ phoneNumber, validPhone: false });
    if (this.props.didSmsCreationFailed) {
      this.props.logout();
    }
  }

  render() {
    const {i18n, isSmsPending, didSmsCreationFailed} = this.props;
    // const errorStatus = this.props.smsStatus.data.get('response', '').status
    // const serverError = errorStatus > 499 ? "phone-step__error" : "phone-step__error-none"
    const error = this.state.validPhone ? <RegularError message={i18n('onboarding.phoneStep.invalidPatternError')}/> : null;
    const errorPhone = didSmsCreationFailed ? <SmallError message={i18n('onboarding.phoneStep.error')}/> : null
    const loading = isSmsPending ? <Spinner /> : null

    return (
      <div className="text-center">
        {/* <div className={serverError}> */}
        <div>
          <p className="form__serverError">{i18n('onboarding.formValidation.serverError')}</p>
        </div>
        <div className="row justify-content-center">
          <div className="col-8 col-sm-0">
            <Title text={i18n('onboarding.phoneStep.welcome')} className="form__title" />
          </div>
        </div>
        <div className="row justify-content-center mb-5 pb-sm-4">
          <div className="col-10 col-sm-7 px-sm-4">
            <p className="form__description mb-0">{i18n('onboarding.phoneStep.text1')}</p>
          </div>
        </div>
        <div className="row justify-content-center mb-5 mb-sm-0">
          <div className="col-8 col-sm-3 px-sm-4">
            <p className="form__description px-2 px-sm-0 font-weight-bold">{i18n('onboarding.phoneStep.text2')}</p>
          </div>
        </div>
        <form onSubmit={this.continue} className="form">
          <fieldset className="mb-5 pb-2 pb-sm-5">
            <input
              style={{ direction: 'ltr'}}
              className={`form__input ${error || errorPhone ? 'form__input--error' : ''}`}
              type="tel"
              onChange={this.setPhone}
              value={this.state.phoneNumber}
              placeholder={i18n('onboarding.phoneStep.phoneNumberPlaceholder')}
            />
            {errorPhone}
            {error}
          </fieldset>
          <Button text={i18n('onboarding.phoneStep.buttonText')} onClick={this.continue} />
        </form>
        {loading}
      </div>
    );
  }
}

PhoneStep.propTypes = {
  i18n: P.func,
  isSmsPending: P.bool,
  didSmsCreationFailed: P.bool,
  isSmsCreated: P.bool,
  isLoggedIn: P.bool
}

const mapStateToProps = state => ({
  isLoggedIn: isLoggedIn(state),
  isSmsCreated: isSmsCreated(state),
  didSmsCreationFailed: didSmsCreationFailed(state),
  isSmsPending: isSmsPending(state),
  i18n: geti18n(state)
});

const actionMakers = {
  fireSmsCreation,
  // clearUserDetails,
  logout
}

export default connect(mapStateToProps, actionMakers)(PhoneStep);



// WEBPACK FOOTER //
// ./src/components/Views/Onboarding/Steps/PhoneStep.js